module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_smoker_right-b0ac204758cdc6c6d3bf2cdc7489bed3.png";